module.exports = __webpack_public_path__ + "img/fingerprint.950cd1a8.webp";